import { createSelector, createSlice } from '@reduxjs/toolkit';

import { SliceNameEnum } from '@app/enums';
import { BaseSearchState, defaultSearchCriteria, defaultSearchFilters } from '@app/models';
import { searchExtraReducers } from '@app/state/slices/search.reducers';

export const initialState: BaseSearchState = {
    isFiltersContentVisible: false,
    searchCriteria: defaultSearchCriteria,
    filters: defaultSearchFilters,
    campaignListingId: undefined,
    page: 1,
    meta: {
        isLoading: false,
        hasSearchChanged: false,
        hasGeoChanged: false,
        lastSearchTimestamp: null,
    },
};

export const searchStateSlice = createSlice({
    name: SliceNameEnum.Search,
    initialState,
    reducers: {},
    extraReducers: builder => {
        searchExtraReducers(builder);
    },
});

const selectSelfState = (state: { [SliceNameEnum.Search]: BaseSearchState }): BaseSearchState => {
    return state[searchStateSlice.name] ?? initialState;
};

export const selectors = {
    selectCampaignListingId: createSelector(selectSelfState, state => state.campaignListingId),

    selectSearchCriteria: createSelector(selectSelfState, state => state.searchCriteria),

    selectSearchFilters: createSelector(selectSelfState, state => state.filters),

    selectPage: createSelector(selectSelfState, state => state.page),

    selectIsSearchLoading: createSelector(selectSelfState, state => state.meta.isLoading),

    selectHasGeoChanged: createSelector(selectSelfState, state => state.meta.hasGeoChanged),

    selectHasSearchChanged: createSelector(selectSelfState, state => state.meta.hasSearchChanged),

    selectSearchLastTimestamp: createSelector(
        selectSelfState,
        state => state.meta.lastSearchTimestamp,
    ),

    selectIsFiltersContentVisible: createSelector(
        selectSelfState,
        state => state.isFiltersContentVisible,
    ),
};

export default searchStateSlice.reducer;
